import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedVerificationBanner = _resolveComponent("SharedVerificationBanner")!
  const _component_SharedLanguage = _resolveComponent("SharedLanguage")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('wallet'))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.b('icon', { wallet: true })),
        innerHTML: _ctx.displayedIcons.wallet
      }, null, 10, _hoisted_1),
      (_ctx.displayedCurrency.fiat)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.b('wallet-group'))
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('label'))
            }, _toDisplayString(_ctx.displayedFiatAmount), 3),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(_ctx.b('wallet-currency'))
            }, [
              _createElementVNode("button", {
                class: _normalizeClass([
              _ctx.b('wallet-currency__toggle', { view: _ctx.view }),
              _ctx.displayedFiatActiveClass,
            ]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFiatToggle && _ctx.handleFiatToggle(...args)))
              }, _toDisplayString(_ctx.displayedFiatCurrency), 3),
              _createElementVNode("div", {
                class: _normalizeClass(
              _ctx.b('wallet-currency__options', { view: _ctx.view, visible: _ctx.isFiatVisible })
            )
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedFiatCurrensies, (option) => {
                  return (_openBlock(), _createElementBlock("button", {
                    class: _normalizeClass(
                _ctx.b('wallet-currency__option', {
                  view: _ctx.view,
                  active: option === _ctx.displayedFiatCurrency,
                })
              ),
                    key: option,
                    onClick: ($event: any) => (_ctx.handleFiatOption(option))
                  }, _toDisplayString(option), 11, _hoisted_2))
                }), 128))
              ], 2)
            ], 2)), [
              [_directive_click_outside, _ctx.handleFiatHide]
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('divider'))
      }, "|", 2),
      (_ctx.displayedCurrency.crypto)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(_ctx.b('wallet-group'))
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('label'))
            }, _toDisplayString(_ctx.displayedCryptoAmount), 3),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(_ctx.b('wallet-currency'))
            }, [
              _createElementVNode("button", {
                class: _normalizeClass([
              _ctx.b('wallet-currency__toggle', { view: _ctx.view }),
              _ctx.displayedCryptoActiveClass,
            ]),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCryptoToggle && _ctx.handleCryptoToggle(...args)))
              }, _toDisplayString(_ctx.displayedCryptoCurrency), 3),
              _createElementVNode("div", {
                class: _normalizeClass(
              _ctx.b('wallet-currency__options', { view: _ctx.view, visible: _ctx.isCryptoVisible })
            )
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedCryptoCurrensies, (option) => {
                  return (_openBlock(), _createElementBlock("button", {
                    class: _normalizeClass(
                _ctx.b('wallet-currency__option', {
                  view: _ctx.view,
                  active: option === _ctx.displayedCryptoCurrency,
                })
              ),
                    key: option,
                    onClick: ($event: any) => (_ctx.handleCryptoOption(option))
                  }, _toDisplayString(option), 11, _hoisted_3))
                }), 128))
              ], 2)
            ], 2)), [
              [_directive_click_outside, _ctx.handleCryptoHide]
            ])
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_SharedVerificationBanner, {
      class: _normalizeClass(_ctx.b('verification-banner'))
    }, null, 8, ["class"]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('group'))
    }, [
      _createVNode(_component_SharedLanguage, {
        class: _normalizeClass(_ctx.b('language')),
        view: "light"
      }, null, 8, ["class"]),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('profile'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('label'))
        }, _toDisplayString(_ctx.displayedUserInfo.email), 3),
        _createElementVNode("button", {
          class: _normalizeClass(_ctx.b('profile-logout')),
          disabled: _ctx.isLogoutDisabled,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.b('icon')),
            innerHTML: _ctx.displayedIcons.logout
          }, null, 10, _hoisted_5)
        ], 10, _hoisted_4)
      ], 2)
    ], 2)
  ], 2))
}